import useArrayState from "@clave/use-array-state";
import cn from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { ApiClient } from "../../ApiClient";
import Spinner from "../../common/Spinner";
import style from "./Memberships.module.scss";
const apiClient = new ApiClient("/api");
export function Memberships({ strings }) {
    const [list, setList] = useArrayState([]);
    const [busy, setBusy] = useState();
    useEffect(() => {
        apiClient
            .get("/memberships/list")
            .then((r) => r.memberships)
            .then(setList);
    }, []);
    const becomeMember = useCallback(async (id) => {
        setBusy(id);
        try {
            var result = await apiClient.post(`/memberships/becomeMember/${id}`, {});
            setList.editWhere((m) => m.id === id, (m) => ({ ...m, customerSubscriptionId: result }));
        }
        finally {
            setBusy(undefined);
        }
    }, []);
    const stopMembership = useCallback(async (id, customerSubscriptionId) => {
        setBusy(id);
        try {
            await apiClient.post(`/subscriptions/unsubscribe`, {
                customerSubscriptionId,
            });
            setList.editWhere((m) => m.id === id, (m) => ({ ...m, customerSubscriptionId: undefined }));
        }
        finally {
            setBusy(undefined);
        }
    }, []);
    return (React.createElement("div", { className: style.list }, list.length ? (list.map((l) => (React.createElement("div", { key: l.id },
        React.createElement("h3", null, l.name),
        React.createElement("button", { disabled: busy === l.id, className: cn("btn", {
                primary: !l.customerSubscriptionId,
            }), onClick: () => l.customerSubscriptionId
                ? stopMembership(l.id, l.customerSubscriptionId)
                : becomeMember(l.id) }, busy === l.id ? (React.createElement(Spinner, { size: "mini" })) : l.customerSubscriptionId ? (strings.active) : (strings.becomeMember)))))) : (React.createElement("span", null, "Du er ikke medlem av noe enn\u00E5"))));
}
